const internalTransferExportStatuses: { [key: string]: string } = {
  new: 'New',
  processed: 'Processed'
}

export const getInternalTransferExportStatusLabel = (name: string) => internalTransferExportStatuses[name] || name
